import React, { useEffect, useRef, useState } from "react";
import { AutoDetail } from "./AutoDetail";
import { Form } from "./Form";
import { FormModal } from "./FormModal";
import { Planes } from "./Planes";
import * as bodyScrollLock from "body-scroll-lock";

var disableBodyScroll = bodyScrollLock.disableBodyScroll;
var enableBodyScroll = bodyScrollLock.enableBodyScroll;

export const PlanesScreen = (props) => {
    const id = props.match.params.id;

    const [vehiculosApi, setvehiculosApi] = useState([]);
    const formRef = useRef(null);

    useEffect(() => {
        fetch("/modelos_planes_cuotas")
            .then((res) => res.json())
            .then((result) => {
                setvehiculosApi(result);
            });
    }, []);

    let vehiculoToShow = null;
    if (vehiculosApi.length !== 0) {
        vehiculosApi.map((veh) => {
            if (veh.id == id) {
                vehiculoToShow = veh;
            }
        });
    }

    // Al entrar desde el desplegable "Suscribite" el link trae el hash y la pantalla arranca
    // posicionada en el formulario de más información, una vez que cargaron los datos del modelo.
    useEffect(() => {
        if (props.location.hash !== "#mas_informacion" || vehiculoToShow == null) {
            return;
        }

        let scrollAlFormulario = setTimeout(() => {
            if (formRef.current) {
                formRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        }, 300);

        return () => clearTimeout(scrollAlFormulario);
    }, [props.location.hash, vehiculosApi, id]);

    let handleOpen = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "1";
        backdrop.style.zIndex = "99999";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "1";
        form.style.zIndex = "999999";

        const optionsBodyScroll = {
            reserveScrollBarGap: true,
        };

        disableBodyScroll(backdrop, optionsBodyScroll);
    };

    let handleClose = () => {
        let backdrop = document.querySelector(".form-modalBackdrop");
        backdrop.style.opacity = "0";
        backdrop.style.zIndex = "-1";

        let form = document.querySelector(".form-modalScreen");
        form.style.opacity = "0";
        form.style.zIndex = "-1";
        enableBodyScroll(backdrop);
    };

    const handleSubscription = async (e, plan) => {
        e.preventDefault();
        const brand = await (await fetch('/api/get_brand')).json();

        try {
            const endpoint = await (await fetch('/api/show_endpoints/wssuscripcion')).json();

            let result = await fetch(
                `${endpoint.url_base}${endpoint.url_variable}?Brand=${brand.nombre}&Modelo=${
                    vehiculoToShow.id_api
                }&PlanCC=${plan.id_plan}&ModeloDesc=${encodeURIComponent(
                    vehiculoToShow.titulo
                )}&PlanDesc=${encodeURIComponent(plan.titulo)}`,
                {
                    cache: 'no-cache'
                }
            );
            result = await result.json();
            if (result.ErrorCodigo === "00") {
                window.open(result.Link, "_blank");
            } else {
                //TODO: ¿Qué hacemo?
                alert(result.ErrorDescripcion);
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    };

    return (
        <>
            <div className="planes">
                {vehiculoToShow != null ? (
                    <div className="planesDiv">
                        <div className="planesDiv--div">
                            <div className="planesDiv--subdiv">
                                <AutoDetail
                                    name={vehiculoToShow.titulo}
                                    model={vehiculoToShow.subtitulo}
                                    price={vehiculoToShow.cuota_desde}
                                    img={vehiculoToShow.hash_foto}
                                    id={vehiculoToShow.id}
                                />

                                <div className="mx-base">
                                    <div className="separator--hor mt-half mb-octa"></div>
                                    <p className="planesDiv--p  mt-half">
                                        {vehiculoToShow.descripcion}
                                    </p>
                                </div>
                            </div>
                            <div className="planesDiv--info-planes">
                                <div className="planes-title">
                                    <h1 className="title20">PLANES</h1>
                                </div>

                                <Planes
                                    planes={vehiculoToShow.Planes[0]}
                                    id={vehiculoToShow.id_api}
                                    handleSubscription={handleSubscription}
                                />
                            </div>
                        </div>
                        <a
                            target="_blank"
                            href={vehiculoToShow.url_externa}
                            className="btn-planes mt-base "
                        >
                            Conocé más sobre tu próximo{" "}
                            <strong>RAM® {vehiculoToShow.Titulo} 0KM</strong>
                        </a>
                        <div
                            className="planesDiv--div"
                            id="mas_informacion"
                            ref={formRef}
                        >
                            <Form
                                id={vehiculoToShow.id_salesforce}
                                vehiculo={vehiculoToShow.Titulo}
                                modelYear={vehiculoToShow.modelYear}
                                handleOpen={handleOpen}
                                pixelTags={vehiculoToShow.pixel_tags}
                            />
                        </div>
                    </div>
                ) : (
                    <div
                        className="spinner-border text-bordo mt-base align-self-center"
                        role="status"
                    >
                    </div>
                )}
            </div>
            <FormModal handleClose={handleClose} />
        </>
    );
};
